import React from "react";
import PropTypes from "prop-types";

import { Card } from "semantic-ui-react";

export function CardLayout({
  onMouseEnter,
  onMouseLeave,
  backgroundColor,
  contentStyle,
  header,
  description,
  descriptionStyle,
  children,
}) {
  return (
    <Card
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      style={{
        border: "1px solid",
        boxShadow: "none",
        backgroundColor: backgroundColor,
        borderColor: "#2D9CDB",
        height: "200px",
        width: "240px",
      }}
      data-test="template-card"
    >
      <Card.Content style={contentStyle}>
        {header && <Card.Header>{header}</Card.Header>}
        {description && (
          <Card.Description style={descriptionStyle}>
            {description}
          </Card.Description>
        )}
        {children}
      </Card.Content>
    </Card>
  );
}

CardLayout.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  backgroundColor: PropTypes.string,
  contentStyle: PropTypes.object,
  header: PropTypes.node,
  description: PropTypes.node,
  descriptionStyle: PropTypes.object,
  children: PropTypes.node,
};

CardLayout.defaultProps = {
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  backgroundColor: "white",
  contentStyle: {},
  header: null,
  descriptionStyle: {},
  children: null,
  description: null,
};

export default CardLayout;
